import { React, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import {
    Grid,
    Button,
    Typography,
    useTheme,
    useMediaQuery,
    Box
} from "@mui/material"
import { CircularProgress } from "@mui/material"

import LoginPrompt from "../login/LoginPrompt"
import resetHeaders from "../../functions/resetHeaders"
import useStyles, { ButtonGridStyles, ButtonStylesStyles, ButtonTextStyles, headerTextStyles, PageTitleStyles, VAListItemStyles } from "./HomePageStyles"
import { getAllStoredVisits } from "../../actions/visitorFeedActions"
import { getAllISOUpdates, getAllActiveEmployees, getAllEmployees, } from "../../actions/isoActions"
import VisitorListItem from "../visitor/VisitorListItem"
import DocumentListItem from "../iso/DocumentListItem"
import { PaperFirmNameStyles } from "../iso/ISOStyles"

function HomePage() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const theme = useTheme()

    const [loading, setLoading] = useState(true)

    const permission = useSelector((state) => state.auth.permissions)

    // boolean flag for small screen size (mobile)
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))

    // Store Variables
    const authenticated = useSelector((state) => state.auth.authenticated)
    const loggedIn = useSelector(
        (state) => state.auth.user && state.auth.user.auth
    )

    // Obtain list of all visits from store (database)
    const allStoredVisits = useSelector(
        (state) => state.visitor.allStoredVisits
    )
    const allISOUpdates = useSelector(
        (state) => state.iso.allISOUpdates
    )

    // Filter all visits for upcoming visits
    const visitorOverview = allStoredVisits.filter(
        (vis) =>
            vis.Active &&
            (new Date().toDateString() ===
                new Date(vis.StartDateTime).toDateString() ||
                new Date() <= new Date(vis.EndDateTime))
    )

    useEffect(() => {
        if (loggedIn) {
            resetHeaders()
            async function runUseEffectFunctions() {
                await dispatch(getAllStoredVisits()) 
                await dispatch(getAllISOUpdates()) 
                await dispatch(getAllEmployees())
                await dispatch(getAllActiveEmployees()) 
                setLoading(false)
            }
            runUseEffectFunctions()
        }
    }, [dispatch, loggedIn])

    const handleOnClickVisitor = () => {
        navigate(`/visitor`)
    }

    const handleOnClickISO = () => {
        navigate(`/iso`)
    }

    return (
        <>
            {authenticated ? (
                <div>
                    <Grid
                        container
                        direction="row"
                        align="center"
                        sx={ButtonGridStyles}
                    >
                        
                        {permission.ViewVisitorAnnouncement && ( 
                            <Grid item size={{ xs: 12, sm: 6 }} align="center" sx={VAListItemStyles}>
                                <Grid item sx={headerTextStyles}>
                                    <Typography
                                        variant="h4"
                                        display='inline'
                                        sx={headerTextStyles}
                                    >
                                        CURRENT & UPCOMING VISITORS
                                    </Typography>
                                    <Box>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={handleOnClickVisitor}
                                            sx={ButtonStylesStyles}
                                        >
                                            <Typography
                                                sx={ButtonTextStyles}
                                            >
                                                see more
                                            </Typography>
                                        </Button>
                                    </Box>
                                </Grid>
                                {visitorOverview.length > 0 ? (
                                    visitorOverview.map((vis) => (
                                        <VisitorListItem
                                            key={vis.VisitId}
                                            visitObj={vis}
                                            past={false}
                                        />
                                    ))
                                ) : (
                                    loading ? (<CircularProgress style={{color: '#DF7A00', marginTop: 16}}/>) : (<Grid
                                        item
                                        size={12}
                                    >
                                        <Typography
                                            align="center"
                                            variant="h6"
                                            sx={PaperFirmNameStyles}
                                        >
                                            <i>No visits to show.</i>
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid> 
                        )}

                    {permission.ViewISODocumentUpdate && (
                        <Grid item size={{ xs: 12, sm: 6 }} align="center" sx={VAListItemStyles}>
                            <Grid item sx={headerTextStyles}>
                                <Typography
                                    variant="h4"
                                    display='inline'
                                    sx={headerTextStyles}
                                >
                                    RECENT ISO UPDATES
                                </Typography>
                                <div>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleOnClickISO}
                                        sx={ButtonStylesStyles}
                                    >
                                        <Typography
                                            color='white'
                                            sx={ButtonTextStyles}
                                        >
                                            see more
                                        </Typography>
                                    </Button>
                                </div>
                            </Grid>
                            {allISOUpdates.length > 0 ? (
                                    allISOUpdates.slice(0, 5).map((doc) => (
                                        <DocumentListItem
                                            key={doc.DocumentUpdateId}
                                            documentObj={doc}
                                        />
                                    ))
                                ) : (
                                    loading ? (<CircularProgress style={{color: '#DF7A00', marginTop: 16}}/>) : (
                                    <Grid
                                        item
                                        size={ 12 }
                                    >
                                        <Typography
                                            align="center"
                                            variant="h6"
                                            sx={PaperFirmNameStyles}
                                        >
                                            <i>No updates to show.</i>
                                        </Typography>
                                    </Grid>
                                ))}
                        </Grid>
                        
                    )}
                    </Grid>
                </div>
            ) : (
                <LoginPrompt />
            )}
        </>
    )
}

export default HomePage
